module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9dfaec413ea561cda64edfcd9aef8523.png";